import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: {
          lastTenders: "Latest tenders",
          viewAll: "View all",
          viewPDF: "View PDF",
          lastContests: "Latest contests",
          moreButton: "More",
          advantagesSection: {
            title: "Advantages of Tajikistan",
            subtitle: "Why invest:",
            items: [
              {
                icon: "FaHandshake",
                title: "Free Economic Zones",
                description:
                  "Preferential conditions for business and investors",
              },
              {
                icon: "FaGlobe",
                title: "Market Access",
                description:
                  "Strategic location with access to Central Asia, China, and India markets",
              },
              {
                icon: "FaChartBar",
                title: "Public-Private Partnership",
                description:
                  "Implementation of joint projects with the government",
              },
              {
                icon: "FaTint",
                title: "Support Programs",
                description: "Financial and legal benefits for business",
              },
              {
                icon: "FaMoneyBill",
                title: "Rich Natural Resources",
                description:
                  "High potential for hydropower and access to mineral reserves",
              },
              {
                icon: "FaUsers",
                title: "Human Capital",
                description:
                  "The highest percentage of young population in Central Asia",
              },
            ],
          },
          showToursTitle: "More information about tour",
          NoAvailable: "Could not load data",
          NoTendersAvailable: "No tenders available at the moment.",
          NoCompetitionsAvailable: "No competitions available at the moment.",
          discover: {
            title: "Discover Tajikistan",
            subtitle: "Invest with inspiration. Explore Tajikistan.",
            description:
              "Discover Tajikistan offers investment tours across the country's regions, where business opportunities combine with cultural heritage and natural beauty.",
            programTitle: "Program includes:",
            programItems: {
              visitCities:
                "visits to key cities and promising locations (see map);",
              meetings:
                "meetings with business and government representatives;",
              presentations: "investment project presentations;",
              hospitality: "as well as immersion in Tajik hospitality.",
            },
            closingText:
              "Discover Tajikistan — open new horizons for investments.",
            mapAlt: "Map of Tajikistan",
            tours: "Tours",
            backToTours: "Back to tours",
            back: "Back",
            allTours: "All Tours",
          },
          millionDollars: "million $",
          charts: {
            foreignInvestment: "Foreign Investment Inflow",
            externalTrade: "External Trade Volume",
            gdp: "Tajikistan GDP",
          },
          Competitions: "Competitions",
          LatestCompetitions: "Latest Competitions",
          "An error occurred. Please try again.":
            "An error occurred. Please try again.",
          "Successfully sent!": "Successfully sent!",
          Gotothejobopeningspage: "Go to the job openings page",
          JobShow: "Vacancy information",
          "View All": "View All",
          NumberofVacancies: "Number of Vacancies",
          LatestVacancies: "Latest vacancies",
          MoreDetails: "More details",
          "Agency Vacancies": "Vacancies",
          AgencyDecr:
            "Our doors are open to those who want to become part of the innovative structure in Tajikistan.",
          ImportanttoKnow: "Important to Know",
          ImportanttoKnowDescr:
            "An electronic citizen's request must necessarily include surname, first name, patronymic or initials of the citizen, address of residence (place of stay) of the citizen, description of the essence of the request, and citizen’s email address. An electronic request from a legal entity must necessarily include full name of the legal entity, location of the legal entity, description of the essence of the request, surname, first name, patronymic of the person authorized to sign the requests, and email address of the legal entity. Electronic requests must be reviewed no later than 15 days from the date of registration, and those requiring additional study and verification must be reviewed no later than 1 month.",
          Message: "Message",
          MessageDescr:
            "We inform you that the exercise of your right to submit a request in the form of an electronic document is carried out in accordance with the legislation of the Republic of Tajikistan, ensuring the protection of rights to privacy, personal and family secrets, including preventing the dissemination of information about the direction of your requests and the disclosure of information contained in your requests related to your private life, and compliance with requirements for processing your personal data.",
          Explorethemap:
            "Explore the map of current and completed innovation projects across Tajikistan.",
          ProjectCoverageMap: "Project Coverage Map",
          SupervisedDirections: "Supervised Directions",
          DirectorPhone: "Phone Number",
          DirectoroftheAgency: "Director",
          ReceptionSchedule: "Reception Schedule",
          Structure: "Structure",
          NameIn:
            "AGENCY OF INNOVATION AND DIGITAL TECHNOLOGIES UNDER  THE PRESIDENT OF THE REPUBLIC OF TAJIKISTAN",
          search: "Search",
          menu: "Menu",
          news: "News",
          seeEveryNews: "See all news",
          "Read more": "Read more",
          Activity: "Activity",
          ActivityDescription:
            "Investment News Center in Tajikistan — initiatives, prospects, and outcomes.",
          "Digitalization and goals": "Digitalization and goals",
          "Achieving 'digital maturity' of key sectors of the economy and social sphere. Creating foundations and potential for the development of an economy based on innovation and knowledge":
            "Achieving 'digital maturity' of key sectors of the economy and social sphere. Creating foundations and potential for the development of an economy based on innovation and knowledge",
          "Development of strategies": "Development of strategies",
          "Promotion of a unified state policy in the field of innovation and digital technology development":
            "Promotion of a unified state policy in the field of innovation and digital technology development",
          "Infrastructure development": "Human Capital",
          "Provision of public services in digital form":
            "Provision of public services in digital form",
          "Security and regulation": "Security and regulation",
          "Management and regulation of the process of using electronic signatures and data protection":
            "Management and regulation of the process of using electronic signatures and data protection",
          "Implementation of e-government": "Implementation of e-government",
          "Management and regulation of the implementation of 'e-government'":
            "Management and regulation of the implementation of 'e-government'",
          "Business and innovation support": "Business and innovation support",
          "Promotion of the digital economy and e-commerce":
            "Promotion of the digital economy and e-commerce",

          agencyTasks: "Agency Tasks",
          agencyDescription:
            "Accelerating economic development to create an inclusive, competitive, and business-friendly climate.",
          task1:
            "Formation, management, and promotion of the process of creating favorable conditions for the digital development of the economic and social sphere of the Republic of Tajikistan.",
          task2:
            "Determining the stages of transition to a digital system of state relations with the population and the private sector.",
          task3:
            "Determining the necessity and possibility of forming and implementing infrastructure to ensure digitalization.",
          task4:
            "Regulating and promoting the activities of public service centers, certification centers, and the development of digital programs.",
          task5:
            "Identifying directions for innovative development and the basics of state support for innovative activities in the Republic of Tajikistan.",
          task6:
            "Forming a mechanism for the commercialization of scientific and technical results of an innovative nature.",

          agencyIssues: "Agency Issues",
          agencyIssueDescription:
            "Accelerating economic development to create an inclusive, competitive, and business-friendly climate.",
          solution1:
            "Development of the infrastructure of the 'Electronic Government' system, which affects the broad application of modern information and communication technologies in the provision of public services and interagency electronic interaction.",
          solution2:
            "Development of the infrastructure of the 'Electronic Government' system, which affects the broad application of modern information and communication technologies in the provision of public services and interagency electronic interaction.",
          solution3:
            "Development of the infrastructure of the 'Electronic Government' system, which affects the broad application of modern information and communication technologies in the provision of public services and interagency electronic interaction.",

          "Contact us": "Contact us",
          name: "Name",
          email: "Email",
          "type messeg": "Message subject:",
          messeg: "Message",
          Send: "Send",
          "Enter your name": "Enter your name",
          "Enter your email": "Enter your email",
          "Enter your messeg": "Enter your message",
          "type messeg select": "Select a topic",
          topicOne: "Write a letter",
          topicTwo: "Report corruption",
          topicThree: "Collective appeal",
          FAQ: "Single Window",

          NumbersTJK: "Tajikistan in Numbers",
          averageAge: "Average Age",
          population: "Population",
          gdpRankCIS: "GDP Growth Rank in CIS",
          gdpRankCA: "GDP Growth Rank in Central Asia",
          youngPopulation: "Percentage under 35 years",
          benefits: "Benefits and Preferences",
          foreignInvestment: "Foreign Investments (million USD)",
          gdpGrowth: "GDP Growth",
          million: "million",
          attashe: "Investment Attaches",

          address: "Address: 734025, Tajikistan, Dushanbe, Rudaki Avenue 40",
          addresss: "",
          phone: "Phone:",
          emaill: "Email: info@tajinvest.tj",
          date: "Date",

          home: "Home",
          activity: "Activity",
          appeals: "Appeals",
          leadership: "Leadership",
          legislativeBase: "Legislative Base",
          vacancies: "Vacancies",
          projectCoverageMap: "Project Coverage Map",
          announcements: "Announcements",

          MainTitle: "Tajikistan - investing in people and potential",
          MainDescription: "Join the growing market",

          projectPr:
            "One of the most important tasks is to create a favorable investment and entrepreneurial climate, support domestic and foreign investors, and attract direct foreign investment in strategic sectors of the economy.",
          PresidentName:
            "Founder of Peace and National Unity – Leader of the Nation, President of the Republic of Tajikistan Emomali Rahmon",
          titleProject: "Briefly about our activities",
          DescriptionProject:
            'The mission of the SUE  "Tajinvest" is to promote the economic growth of Tajikistan by attracting investments, supporting entrepreneurship, and developing state assets, creating favorable conditions for successful business.',
          Projects: "Projects",
          All: "All",
          Tenders: "Tenders",
          MapTitle: "Investment Map of Tajikistan",
          region: "region",
          description: "description",
          filter: "Filter by directions",
          GBAO: "GBAO",
          Sogd: "Sughd",
          RRP: "DRS",
          Khatlon: "Khatlon",
          InvestGuide: "Investor's Guide",
          AllProjects: "All projects",
          WholeMap: "Whole map",
          emblemTitle:
            "State Committee on Investments and State Property Management of the Republic of Tajikistan",
          logoTitle: "State Unitary  Enterprise",
          logoTaj: '"Tajinvest"',
          titleMaps: "Innovative regions",
          "Re more maps": "Read more",
          "Latest projects": "Latest projects",
          "More details": "More details",
          Sifrtitle: "Investment Advantages in Tajikistan",
          SifrDescription:
            "Discover new opportunities in a rapidly developing region — favorable conditions, natural wealth, and a young labor force await you in Tajikistan.",

          "Free Economic Zones": "Strategy development",
          "Sifr solotions title1": "Free Economic Zones",
          "Sifr solotions descriptions1":
            "Preferential Conditions for Business and Investors",
          "Sifr solotions title2": "Implementation of e-government",
          "Sifr solotions descriptions2":
            "The Highest Percentage of Young Population in Central Asia",
          "Sifr solotions title3": "Public-Private Partnership",
          "Sifr solotions descriptions3":
            "Implementation of Joint Projects with the Government",
          "Sifr solotions title4": "Access to Markets",
          "Sifr solotions descriptions4":
            "Strategic Location with Access to the Markets of Central Asia, China, and India",
          "Sifr solotions title5": "Rich Natural Resources",
          "Sifr solotions descriptions5":
            "Great Potential for Hydropower Development and Access to Mineral Reserves",
          "More about the agency": "More",
          "Latest news": "Latest news",
          projectCoverageMapMenu: "For investors",
          singleWindow: {
            title: "ONE-STOP SHOP",
            subtitle: "What we provide:",
            services: [
              {
                title: "Development of Investment Strategies",
                description:
                  "Project selection and risk management to achieve investment goals",
              },
              {
                title: "Organization of Business Forums",
                description:
                  "Holding events to facilitate interaction between investors, entrepreneurs, and government bodies",
              },
              {
                title: "Support of Investment Projects",
                description:
                  "Support at every investment stage: from planning to implementation",
              },
              {
                title: "Legal Support",
                description: "Providing full legal support for projects",
              },
              {
                title: "Tax Consulting",
                description:
                  "Consultations on taxation issues to optimize tax expenses",
              },
              {
                title: "Project Search Consulting",
                description:
                  "Assistance in finding and selecting promising projects for investments",
              },
            ],
          },
          investForum: {
            menu: "G10 Insights Forum",
            breadcrumbHome: "Home",
            breadcrumbEvents: "Events",
            breadcrumbCurrent: "G10 Insights Forum 2026",
            logoTitle: "G10",
            logoSubLine1: "INSIGHTS FORUM",
            logoSubLine2: "2026",
            heroTitle: "G10 Insights Forum 2026",
            heroTagline:
              "International Forum of Ideas, Business and New Opportunities",
            heroTagline2: "",
            locationCity: "Dushanbe, Tajikistan",
            venue: "Kohi Vahdat",
            date: "October 15, 2026",
            registerNow: "Buy Ticket",
            downloadProgram: "DOWNLOAD AGENDA",
            downloadConcept: "Download Concept",
            learnMore: "Learn More",
            viewAllSpeakers: "View All Speakers",
            learnMoreAboutForum: "Learn more about the Forum",
            heroImageLabel: "Hero background photo",
            stats: [
              { value: "1000+", label: "Participants" },
              { value: "10", label: "Global Speakers" },
              { value: "50+", label: "Countries" },
              { value: "100+", label: "Investment Meetings" },
            ],
            aboutEyebrow: "About the Forum",
            aboutTitle: "G10 Insights Forum",
            aboutText1:
              "G10 Insights Forum is an international business platform bringing together successful entrepreneurs, investors, business leaders, and experts to exchange practical experience, ideas, and business growth strategies.",
            aboutText2:
              "The Forum gives participants an opportunity to learn from real success stories, key business decisions, and professional insights from leaders across different countries, while building new business connections, developing partnerships, and exploring new opportunities for business and investment.",
            aboutImageLabel: "Panel discussion photo",
            missionHeading: "Mission & Goals",
            missionGoals: [
              {
                title: "EXCHANGE OF EXPERIENCE & INSIGHTS",
                text: "Creating an international platform for exchanging practical knowledge, experience, and ideas among entrepreneurs, investors, and business leaders.",
              },
              {
                title: "SUCCESS STORIES",
                text: "Exploring the professional journeys of leaders, their key decisions, growth strategies, and experience in building and scaling successful businesses.",
              },
              {
                title: "BUSINESS LEADERS COMMUNITY",
                text: "Bringing together entrepreneurs, investors, company executives, and experts from different countries on one professional platform.",
              },
              {
                title: "NEW OPPORTUNITIES FOR GROWTH",
                text: "Creating new business connections, developing partnerships, and opening new opportunities for business, investment, and joint projects.",
              },
            ],
            speakersHeading: "Speakers",
            speakerPhotoLabel: "Speaker photo",
            speakers: [
              {
                name: "Dilshod Jurazoda",
                title:
                  "General Director of the State Unitary Enterprise Tajinvest.",
                topic:
                  "Presentation Topic: Investment Opportunities of Tajikistan",
                linkedin:
                  "https://www.linkedin.com/in/dilshod-jurazoda/?locale=ru",
                instagram: "https://www.instagram.com/iamdi55erent/",
                country: "TJ",
              },
              {
                name: "Gagan Malhotra",
                title:
                  "Entrepreneur, Investor, Managing Director of CHL International, owner of the Hilton Dushanbe Hotel. Vice chairman of AmCham Tajikistan.",
                topic:
                  'Presentation Topic: Tourism: The Engine of Tajikistan\'s Growth"The Growth Engine for Tajikistan"',
                linkedin:
                  "https://www.linkedin.com/in/gagan-malhotra-18362414/",
                instagram: null,
                country: "IN",
              },
              {
                name: "Elena V. Son-LaRocco",
                title:
                  "Executive Director of the US–Tajikistan Business Council, business leader and expert in developing economic relations between the United States and Central Asia.",
                topic:
                  'Presentation Topic:" US and Cenral Asia: Building Mutually Beneficial Busniness Parthnerships"',
                linkedin: "https://www.linkedin.com/in/elenavson/",
                instagram: null,
                country: "US",
              },
              {
                name: "Taejun Shin",
                title:
                  "Founder, Managing Partner and CEO of Gojo & Company (Japan).",
                topic:
                  "Presentation Topic: Gojo: Advancing Financial Inclusion in Central Asia and Beyond",
                linkedin: "https://www.linkedin.com/in/taejun-shin-185480a5/",
                instagram: null,
                country: "JP",
              },
              {
                name: "Anastasia Antsiferova",
                title:
                  "Entrepreneur, business speaker and expert in restaurant business development, marketing and team management.",
                topic:
                  'Presentation Topic: "Create a concept restaurant from scratch or buy a frachise. Experience from two sides"',
                linkedin: null,
                instagram: "https://www.instagram.com/marpha_feeling_good",
                country: "RU",
              },
              {
                name: "Saidmurod Davlatov",
                title:
                  "Founder of the SAMO International Human Development Center, entrepreneur, investor and business coach.",
                topic:
                  "Presentation Topic: Profit Growth System Without Increasing Workload",
                linkedin:
                  "https://www.linkedin.com/in/%D1%81%D0%B0%D0%B8%D0%B4%D0%BC%D1%83%D1%80%D0%BE%D0%B4-%D0%B4%D0%B0%D0%B2%D0%BB%D0%B0%D1%82%D0%BE%D0%B2-a9953a263/",
                instagram: "https://www.instagram.com/saidmurod_davlatov",
                country: "TJ",
              },
              {
                name: "Ozodkhon Davlatshoev",
                title: "Top Manager, Telecom & Digital Expert, CEO of Tcell",
                topic:
                  "Presentation Topic: From Connectivity to Digital Trust: Tcell as the Infrastructure Layer of Tajikistan’s Digital Economy",
                linkedin: "https://www.linkedin.com/in/ozodkhonceoiixviivi/",
                instagram: "https://www.instagram.com/ozodkhon.davlatshoev",
                country: "TJ",
              },
              {
                name: "Behdad Zeinal Ganbar Nejad",
                title:
                  "Founder of BuranPars LLC, entrepreneur and Moscow Export Center Ambassador in Iran, expert in Russian–Iranian trade and investment cooperation.",
                topic:
                  "Presentation Topic: Iran — Central Asia: New Investment and Cooperation Opportunities",
                linkedin: null,
                instagram: null,
                country: "IR",
              },
              {
                name: "Abdurashid Iminov",
                title:
                  "Founder and CEO of Gōsht Group, international entrepreneur and expert in the restaurant and hospitality industry.",
                topic: "Presentation Topic: International Expansion Strategy",
                linkedin:
                  "https://www.linkedin.com/in/abdurashid-iminov-05a8a7273/",
                instagram: "https://www.instagram.com/abdurashid_iminov",
                country: "UZ",
              },
              {
                name: "Harpreet Singh Maan",
                title:
                  "CEO of TEIZA, President of the Blockchain Association Malaysia, serial entrepreneur and expert in Blockchain and DLT.",
                topic:
                  "Presentation Topic: Digital Tajikistan: The Heart of Central Asia's Digital Economy",
                linkedin: "https://www.linkedin.com/in/harpreet-maan/",
                instagram: null,
                country: "MY",
              },
            ],
            agendaEyebrow: "Forum Agenda",
            agenda: [
              {
                time: "09:00 – 10:00",
                text: "Participant registration. Welcome coffee",
              },
              { time: "10:00 – 10:30", text: "Forum opening ceremony" },
              { time: "10:30 – 13:00", text: "SESSION 1 — SUCCESS STORIES" },
              {
                time: "10:30 – 11:00",
                text: "Taejun Shin (in English) — Founder, Managing Partner and CEO of Gojo & Company (Japan)\nTopic: Gojo: Advancing Financial Inclusion in Central Asia and Beyond",
              },
              {
                time: "11:00 – 11:30",
                text: "Gagan Malhotra (in English) — General Director of CJSC CHL International, owner of Hilton Dushanbe. Managing Partner of Amnis Ventures FZCO (Dubai) and Vice Chairman of AmCham Tajikistan\nTopic: Tourism: The Growth Engine for Tajikistan",
              },
              {
                time: "11:30 – 12:00",
                text: "Anastasia Antsiferova — Entrepreneur, business speaker and expert in restaurant business development, marketing and team management\nTopic: From a Local Idea to a Big Market: How a Restaurant Brand Becomes an Investment Product",
              },
              {
                time: "12:00 – 12:30",
                text: "Saidmurod Davlatov — Founder of the SAMO International Human Development Center, entrepreneur, investor and business coach\nTopic: Profit Growth System Without Increasing Workload",
              },
              {
                time: "12:30 – 13:00",
                text: "Ozodkhon Davlatshoev — Top Manager, Telecom & Digital Expert, CEO of Tcell\nTopic: From Connectivity to Digital Trust: Tcell as the Infrastructure Layer of Tajikistan’s Digital Economy",
              },
              {
                time: "13:00 – 14:00",
                text: `Panel session:
“E-Commerce as a Driver of Investment: Marketplaces, Payments, and Next-Generation Logistics”

Moderator: Nasima Bahramova — Chairwoman of the Association of E-Commerce Participants of Tajikistan

Expected panel participants:
• Iftikhor Yusufi — LAK LAK Marketplace
• Muhammadjon Kudratullozoda — Mavsim and K 
• Yaroslav Efremiin — “Parvona” Project
• Bonu Boboeva — Zehnlab.ai
• Gulanor Atobek — Representative of a Fintech Company / Payment System - Alif Bank`,
              },
              { time: "14:00 – 15:00", text: "Lunch break" },
              {
                time: "15:00 – 17:30",
                text: "SESSION 2 — INVESTMENT OPPORTUNITIES",
              },
              {
                time: "15:00 – 15:30",
                text: "Dilshod Jurazoda — General Director of the State Unitary Enterprise “Tajinvest”\nTopic: “Investment Opportunities of Tajikistan”",
              },
              {
                time: "15:30 – 16:00",
                text: "Elena V. Son-LaRocco — Executive Director of the U.S.–Tajikistan Business Council, business leader and expert in developing economic ties between the U.S. and Central Asia\nTopic: US and Cenral Asia: Building Mutually Beneficial Busniness Parthnerships",
              },
              {
                time: "16:00 – 16:30",
                text: "Behdad Zeinal Ganbar Nejad — Founder of BuranPars LLC, entrepreneur, Moscow Export Center Ambassador in Iran\nTopic: Iran-Central Asia: New Opportunities for Investment and Cooperation",
              },
              {
                time: "16:30 – 17:00",
                text: "Abdurashid Iminov — Founder and CEO of Gōsht Group, international entrepreneur and expert in the restaurant and hospitality industry\nTopic: “International Expansion Strategy”",
              },
              {
                time: "17:00 – 17:30",
                text: "Harpreet Singh Maan — CEO of TEIZA, President of the Blockchain Association Malaysia, serial entrepreneur and expert in Blockchain and DLT\nTopic: “Digital Tajikistan: The Heart of Central Asia's Digital Economy”",
              },
              {
                time: "17:30 – 18:00",
                text: "Forum summary and closing remarks",
              },
              { time: "18:00 – 18:30", text: "Closing ceremony" },
            ],
            expoHeading: "Exhibition Zone",
            expoTitle: "Present Your Project to an International Audience",
            expoText:
              "Showcase your company, business project, product, or innovative solution at G10 Insights Forum 2026. Present your ideas to entrepreneurs, investors, business leaders, and potential partners, build new business connections, and discover new opportunities for cooperation and growth.",
            expoDeadline: "Applications are accepted until October 5.",
            expoButton: "Submit Application",
            expoImageLabel: "Exhibition booth photo",
            outcomesHeading: "Expected Outcomes",
            outcomes: [
              { title: "Practical Insights" },
              { title: "New Knowledge and Experience" },
              { title: "International Partnerships" },
              { title: "New Business Connections" },
              { title: "Joint Projects and Initiatives" },
              { title: "New Opportunities for Growth" },
            ],
            organizersHeading: "Organizers",
            organizerLogoLabel: "Logo",
            organizers: [
              {
                name: "State Committee on Investments and State Property Management of the Republic of Tajikistan",
              },
              {
                name: 'State Unitary Enterprise "Tajinvest"',
                highlight: "TAJINVEST",
              },
              { name: "Executive Body of State Authority of Dushanbe City" },
            ],
            partnersHeading: "Partners",
            partnerCategories: [
              "General Sponsor",
              "Sponsors",
              "Development Partner",
              "Partners",
              "Media Partner",
            ],
            ctaTitle: "Be part of the community shaping the future of business",
            ctaSubtitle: "Join G10 Insights Forum 2026",
          },
        },
      },
      ru: {
        translation: {
          lastTenders: "Последние тендеры",
          viewAll: "Смотреть все",
          viewPDF: "Смотреть PDF",
          lastContests: "Последние конкурсы",
          moreButton: "Подробнее",
          advantagesSection: {
            title: "Преимущества Таджикистана",
            subtitle: "Почему стоит инвестировать:",
            items: [
              {
                icon: "FaHandshake",
                title: "Свободные экономические зоны",
                description: "Льготные условия для бизнеса и инвесторов",
              },
              {
                icon: "FaGlobe",
                title: "Доступ к рынкам",
                description:
                  "Выгодное расположение с доступом к рынкам Центральной Азии, Китая и Индии",
              },
              {
                icon: "FaChartBar",
                title: "Государственно-частное партнёрство",
                description: "Реализация совместных проектов с государством",
              },
              {
                icon: "FaTint",
                title: "Программы поддержки",
                description: "Финансовые и правовые льготы для бизнеса",
              },
              {
                icon: "FaMoneyBill",
                title: "Богатые природные ресурсы",
                description:
                  "Большой потенциал для развития гидроэнергетики и доступ к запасам полезных ископаемых",
              },
              {
                icon: "FaUsers",
                title: "Человеческий капитал",
                description:
                  "Самый высокий процент молодого населения в Центральной Азии",
              },
            ],
          },
          showToursTitle: "Подробнее о туре",
          NoAvailable: "Не удалось загрузить данные",
          NoTendersAvailable: "На данный момент тендеров нет.",
          NoCompetitionsAvailable: "На данный момент конкурсов нет.",
          discover: {
            title: "Открой Таджикистан",
            subtitle: "Инвестируй с вдохновением. Открывай Таджикистан.",
            description:
              "Discover Tajikistan — это инвестиционные туры по регионам страны, где деловые возможности сочетаются с культурным наследием и природной красотой.",
            programTitle: "Программа включает:",
            programItems: {
              visitCities:
                "посещение ключевых городов и перспективных локаций (см. карту);",
              meetings: "встречи с представителями бизнеса и власти;",
              presentations: "презентации инвестиционных проектов;",
              hospitality:
                "а также погружение в атмосферу таджикского гостеприимства.",
            },
            closingText:
              "Открой Таджикистан — открой новые горизонты для инвестиций.",
            mapAlt: "Карта Таджикистана",
            tours: "Туры",
            backToTours: "Назад к турам",
            back: "Назад",
            allTours: "Все туры",
          },
          millionDollars: "млн. долл.",
          charts: {
            foreignInvestment: "Объём притока иностранных инвестиций",
            externalTrade: "Объём внешнеторгового оборота",
            gdp: "ВВП Таджикистана",
          },
          singleWindow: {
            title: " ONE-STOP SHOP",
            subtitle: "Что мы предоставляем:",
            services: [
              {
                title: "Разработка инвестиционных стратегий",
                description:
                  "Подбор проектов и управление рисками для достижения инвестиционных целей",
              },
              {
                title: "Организация бизнес-форумов",
                description:
                  "Проведение мероприятий для содействия взаимодействию инвесторов, предпринимателей и государственных структур",
              },
              {
                title: "Сопровождение инвестиционных проектов",
                description:
                  "Поддержка на каждом этапе инвестирования: от планирования до реализации",
              },
              {
                title: "Юридическая поддержка",
                description:
                  "Предоставление полного юридического сопровождения проектов",
              },
              {
                title: "Налоговое консультирование",
                description:
                  "Консультации по вопросам налогообложения для оптимизации налоговых затрат",
              },
              {
                title: "Консалтинг в поиске проектов",
                description:
                  "Помощь в нахождении и выборе перспективных проектов для инвестиций",
              },
            ],
          },
          Competitions: "Конкурсы",
          Tenders: "Тендеры",
          All: "Все",
          MapTitle: "Инвестиционная карта Таджикистана",
          region: "регион",
          description: "описание",
          filter: "Сортировать по направлениям",
          GBAO: "ГБАО",
          Sogd: "Согд",
          RRP: "РРП",
          Khatlon: "Хатлон",
          InvestGuide: "Путеводитель инвестора",
          AllProjects: "Все проекты",
          WholeMap: "Вся карта",
          emblemTitle:
            "Государственный комитет по инвестициям и управлению государственным имуществом Республики Таджикистан",
          "Latest news": "Последние новости",
          logoTitle: "Государственное унитарное предприятие ",
          logoTaj: '"Таджинвест"',
          LatestCompetitions: "Последние конкурсы",
          "An error occurred. Please try again.":
            "Произошла ошибка. Попробуйте снова.",
          "Successfully sent!": "Успешно отправлено!",
          Gotothejobopeningspage: "Перейти на страницу открытых вакансий",
          JobShow: "Информация о вакансии",
          "View All": "Смотреть все",
          NumberofVacancies: " Количество вакансий",
          AgencyDecr:
            "Наши двери открыты для тех, кто хочет стать частью инновационной структуры в Таджикистане.",
          LatestVacancies: "Последние вакансии",
          MoreDetails: "Подробнее",
          "Agency Vacancies": "Вакансии",
          Message: "Обращение",
          ImportanttoKnow: "Важно знать",
          ImportanttoKnowDescr:
            "Электронное обращение гражданина в обязательном порядке должно содержать фамилию, имя, отчество либо инициалы гражданина, адрес места жительства (места пребывания) гражданина, изложение сути обращения и адрес электронной почты гражданина. Электронное обращение юридического лица в обязательном порядке должно содержать полное наименование юридического лица, место нахождения юридического лица, изложение сути обращения, фамилию, имя, отчество лица, уполномоченного подписывать обращения, и адрес электронной почты юридического лица. Электронные обращения должны быть рассмотрены не позднее 15 дней со дня регистрации, а требующие дополнительного изучения и проверки – не позднее 1 месяца.",
          MessageDescr:
            "Мы информируем вас, что осуществление вами права на обращение в форме электронного документа осуществляется в соответствии с законодательством Республики Таджикистан с обеспечением защиты прав на неприкосновенность частной жизни, личную и семейную тайну, в том числе недопущения распространения информации о направлении вами обращений и разглашения сведений, содержащихся в ваших обращениях и касающихся вашей частной жизни, соблюдения требований при обработке ваших персональных данных.",
          Explorethemap:
            "Изучите карту текущих и завершенных инновационных проектов по всей территории Таджикистана.",
          ProjectCoverageMap: "Карта покрытия проектов",
          SupervisedDirections: "Курируемые направления",
          DirectorPhone: "Телефон",
          DirectoroftheAgency: "Директор",
          ReceptionSchedule: "График приема",
          Structure: "Структура",
          NameIn:
            "АГЕНТСТВО ИННОВАЦИЙ И ЦИФРОВЫХ ТЕХНОЛОГИЙ ПРИ ПРЕЗИДЕНТЕ РЕСПУБЛИКИ ТАДЖИКИСТАН",
          search: "Поиск",
          menu: "Меню",
          news: "Новости",
          seeEveryNews: "Посмотреть все новости",
          million: "млн",
          attashe: "Инвестиционные атташе",
          "Read more": "Читать дальше",
          Activity: "Деятельность",
          ActivityDescription:
            "Центр новостей об инвестициях в Таджикистан — инициативы, перспективы, результаты.",
          "Digitalization and goals": "Цифровизация и цели",
          "Achieving 'digital maturity' of key sectors of the economy and social sphere. Creating foundations and potential for the development of an economy based on innovation and knowledge":
            "Достижение «цифровой зрелости» ключевых отраслей экономики и социальной сферы. Создание основ и потенциала для развития экономики на основе инноваций и знаний",
          "Development of strategies": "Разработка стратегий",
          "Promotion of a unified state policy in the field of innovation and digital technology development":
            "Продвижение единой государственной политики в области развитие инноваций и цифровых технологий",
          "Infrastructure development": "Человеческий капитал",
          "Provision of public services in digital form":
            "Предоставление государственных услуг в цифровой форме",
          "Security and regulation": "Безопасность и рушулировка",
          "Management and regulation of the process of using electronic signatures and data protection":
            "Управление и регулирование процесса использования электронных подписей и защиты данных",
          "Implementation of e-government":
            "Внедрение электронного правительства",
          "Management and regulation of the implementation of 'e-government'":
            "Управление и регулирование процесса внедрения «электронного правительства»",
          "Business and innovation support": "Поддержка бизнеса и инноваций",
          "Promotion of the digital economy and e-commerce":
            "Продвижение цифровой экономики и электронной торговли",

          agencyTasks: "Задачи агентства",
          agencyDescription:
            "Ускорение развития экономики для создания инклюзивного,конкурентоспособного и благоприятного делового климата.",
          task1:
            "Формирование, управление и продвижение процесса создания благоприятных условий для цифрового развития экономической и социальной сферы Республики Таджикистан.",
          task2:
            "Определение этапов перехода к цифровой системе регулирования отношений государства с населением и частным сектором.",
          task3:
            "Определение необходимости и возможности формирования и внедрения инфраструктуры обеспечения цифровизации.",
          task4:
            "Регулирование и продвижение деятельности центров государственных услуг, удостоверяющих центров и разработки цифровых программ.",
          task5:
            "Определение направлений инновационного развития и основ государственной поддержки инновационной деятельности в Республике Таджикистан.",
          task6:
            "Формирование механизма коммерциализации научно-технических результатов инновационного характера.",

          agencyIssues: "Агентство решение следующих вопросов",
          agencyIssueDescription:
            "Ускорение развития экономики для создания инклюзивного, конкурентоспособного и благоприятного делового климата.",
          solution1:
            "Развитие инфраструктуры системы «Электронное правительство», что сказывается на обеспечении широкого применения современных информационно-коммуникационных технологий при оказании государственных услуг и межведомственном электронном взаимодействии.",
          solution2:
            "Развитие инфраструктуры системы «Электронное правительство», что сказывается на обеспечении широкого применения современных информационно-коммуникационных технологий при оказании государственных услуг и межведомственном электронном взаимодействии.",
          solution3:
            "Развитие инфраструктуры системы «Электронное правительство», что сказывается на обеспечении широкого применения современных информационно-коммуникационных технологий при оказании государственных услуг и межведомственном электронном взаимодействии.",

          "Contact us": "Свяжитесь с нами",
          name: "Имя",
          email: "Электронная почта",
          "type messeg": "Тема сообщения:",
          messeg: "Сообщение",
          Send: "Отправить",
          "Enter your name": "Введите ваше имя",
          "Enter your email": "Введите ваш email",
          "Enter your messeg": "Введите сообщение",
          "type messeg select": "Выберите тему",
          topicOne: "Написать письмо",
          topicTwo: "Сообщить о коррупции",
          topicThree: "Коллективное обращение",
          FAQ: "Единое окно",

          NumbersTJK: "Таджикистан в цифрах",
          averageAge: "Средний возраст",
          population: "Население",
          gdpRankCIS: "Место по росту ВВП в СНГ",
          gdpRankCA: "Место по росту ВВП в ЦА",
          youngPopulation: "Кол-во жителей моложе 35 лет",
          benefits: "Льготы и преференции",
          foreignInvestment: "Иностранные инвестиции (млн долл. США)",
          gdpGrowth: "Прирост ВВП",

          address: "Адрес: 734025, Таджикистан, Душанбе, проспект Рудаки 40",
          addresss: "",
          phone: "Телефон:",
          emaill: "Электронная почта: info@tajinvest.tj",
          date: "Дата",
          home: "Главная страница",
          activity: "Деятельность",
          appeals: "Обращения",
          leadership: "Руководство",
          legislativeBase: "Законодательная база",
          vacancies: "Вакансии",
          projectCoverageMap: "Карта покрытия проектов",
          projectCoverageMapMenu: "Инвесторам",
          announcements: "Объявления",

          MainTitle: "Таджикистан - инвестиции в людей и потенциал",
          MainDescription: "Присоединяйтесь к растущему рынку",

          projectPr:
            "Одной из важнейших задач является создание благоприятного инвестиционного и предпринимательского климата, поддержка отечественных и иностранных инвесторов, а также привлечение прямых иностранных инвестиций в стратегические отрасли экономики.",
          PresidentName:
            "Основатель мира и национального единства – Лидер нации, Президент Республики Таджикистан Эмомали Рахмон",
          titleProject: "Коротко о нашей деятельности",
          DescriptionProject:
            'Миссия ГУП "Таджинвест" — содействие экономическому росту Таджикистана путем привлечения инвестиций, поддержки предпринимательства и развития государственных активов, создавая благоприятные условия для успешного бизнеса.',
          Projects: "Проекты",
          titleMaps: "Инновационные регионы",
          "Re more maps": "Ознакомиться подробнее",
          "Latest projects": "Последние проекты",
          "More details": "Подробнее",
          Sifrtitle: "Преимущества инвестиций в Таджикистан",
          SifrDescription:
            "Откройте для себя новые возможности в быстроразвивающемся регионе — выгодные условия, природные богатства и молодой трудовой потенциал ждут вас в Таджикистане.",

          "Sifr solotions title1": "Свободные экономические зоны",
          "Sifr solotions descriptions1":
            "Льготные условия для бизнеса и инвесторов",
          "Sifr solotions title2": "Внедрение электронного правительства ",
          "Sifr solotions descriptions2":
            "Самый высокий процент молодого населения в Центральной Азии",
          "Sifr solotions title3": "Государственно-частное партнёрство",
          "Sifr solotions descriptions3":
            "Реализация совместных проектов с государством",
          "Sifr solotions title4": "Доступ к рынкам",
          "Sifr solotions descriptions4":
            "Выгодное расположение с доступом к рынкам Центральной Азии, Китая и Индии",
          "Sifr solotions title5": "Богатые природные ресурсы",
          "Sifr solotions descriptions5":
            "Большой потенциал для развития гидроэнергетики и доступ к запасам полезных ископаемых",
          "More about the agency": "Подробнее",
          investForum: {
            menu: "G10 Insights Forum",
            breadcrumbHome: "Главная",
            breadcrumbEvents: "Мероприятия",
            breadcrumbCurrent: "G10 Insights Forum 2026",
            logoTitle: "G10",
            logoSubLine1: "ФОРУМ ИНСАЙТОВ",
            logoSubLine2: "2026",
            heroTitle: "G10 Insights Forum 2026",
            heroTagline:
              "Международный форум идей, бизнеса и новых возможностей",
            heroTagline2: "",
            locationCity: "Душанбе, Таджикистан",
            venue: "Кохи Вахдат",
            date: "15 октября 2026",
            registerNow: "Приобрести билет",
            downloadProgram: "СКАЧАТЬ ПРОГРАММУ",
            downloadConcept: "Скачать концепцию",
            learnMore: "Подробнее",
            viewAllSpeakers: "Все спикеры",
            learnMoreAboutForum: "Подробнее о форуме",
            heroImageLabel: "Фоновое фото",
            stats: [
              { value: "1000+", label: "Участников" },
              { value: "10", label: "Мировых спикеров" },
              { value: "50+", label: "Стран" },
              { value: "100+", label: "Инвестиционных встреч" },
            ],
            aboutEyebrow: "О форуме",
            aboutTitle: "G10 Insights Forum",
            aboutText1:
              "G10 Insights Forum — международная деловая платформа, объединяющая успешных предпринимателей, инвесторов, руководителей компаний и экспертов для обмена практическим опытом, идеями и стратегиями развития бизнеса.",
            aboutText2:
              "Форум предоставляет участникам возможность познакомиться с реальными историями успеха, ключевыми бизнес-решениями и профессиональными инсайтами лидеров из разных стран, а также установить новые деловые контакты, развить партнёрства и открыть новые возможности для бизнеса и инвестиций.",
            aboutImageLabel: "Фото панельной дискуссии",
            missionHeading: "Миссия и цели",
            missionGoals: [
              {
                title: "ОБМЕН ОПЫТОМ И ИНСАЙТАМИ",
                text: "Создание международной платформы для обмена практическими знаниями, опытом и идеями между предпринимателями, инвесторами и лидерами бизнеса.",
              },
              {
                title: "ИСТОРИИ УСПЕХА",
                text: "Знакомство с профессиональным путём лидеров, их ключевыми решениями, стратегиями развития и опытом создания и масштабирования бизнеса.",
              },
              {
                title: "СООБЩЕСТВО БИЗНЕС-ЛИДЕРОВ",
                text: "Объединение предпринимателей, инвесторов, руководителей компаний и экспертов из разных стран на одной профессиональной платформе.",
              },
              {
                title: "НОВЫЕ ВОЗМОЖНОСТИ ДЛЯ РОСТА",
                text: "Создание новых деловых контактов, развитие партнёрств и открытие возможностей для бизнеса, инвестиций и совместных проектов.",
              },
            ],
            speakersHeading: "Спикеры",
            speakerPhotoLabel: "Фото спикера",
            speakers: [
              {
                name: "Дилшод Джуразода",
                title: "Генеральный директор ГУП «Таджинвест»",
                topic:
                  "Тема презентации 'Инвестиционные возможности Таджикистана'",
                linkedin:
                  "https://www.linkedin.com/in/dilshod-jurazoda/?locale=ru",
                instagram: "https://www.instagram.com/iamdi55erent/",
                country: "TJ",
              },
              {
                name: "Гаган Малхотра",
                title:
                  "Предприниматель, инвестор, управляющий директор CHL International, владелец отеля Hilton Dushanbe. Заместитель председателя AmCham Tajikistan.",
                topic:
                  "Тема презентации «Туризм: двигатель роста Таджикистана»",
                linkedin:
                  "https://www.linkedin.com/in/gagan-malhotra-18362414/",
                instagram: null,
                country: "IN",
              },
              {
                name: "Елена Сон-ЛаРокко",
                title:
                  "Исполнительный директор Делового совета США - Таджикистан, бизнес-лидер и эксперт по развитию экономических связей между США и Центральной Азией.",
                topic:
                  'Тема презинтации: " США и Центральная Азия: построение взаимовыгодных деловых партнерств"',
                linkedin: "https://www.linkedin.com/in/elenavson/",
                instagram: null,
                country: "US",
              },
              {
                name: "Тэджун Шин",
                title:
                  "Основатель, управляющий партнёр и генеральный директор Gojo & Company (Япония).",
                topic:
                  "Тема презентации «Годжо: Продвижение финансовой доступности в Центральной Азии и за ее пределами»",
                linkedin: "https://www.linkedin.com/in/taejun-shin-185480a5/",
                instagram: null,
                country: "JP",
              },
              {
                name: "Анастасия Анциферова",
                title:
                  "Предприниматель, бизнес-спикер и эксперт по развитию ресторанного бизнеса, маркетингу и управлению командами.",
                topic:
                  'Тема презентации: "Создать концептуальный ресторан с нуля или купить  франшизу.Опыт с двух сторон"',
                linkedin: null,
                instagram: "https://www.instagram.com/marpha_feeling_good",
                country: "RU",
              },
              {
                name: "Саидмурод Давлатов",
                title:
                  "Основатель Международного центра развития человека «САМО», предприниматель, инвестор и бизнес-тренер",
                topic:
                  "Тема презентации 'Система роста прибыли без увеличения нагрузки'",
                linkedin:
                  "https://www.linkedin.com/in/%D1%81%D0%B0%D0%B8%D0%B4%D0%BC%D1%83%D1%80%D0%BE%D0%B4-%D0%B4%D0%B0%D0%B2%D0%BB%D0%B0%D1%82%D0%BE%D0%B2-a9953a263/",
                instagram: "https://www.instagram.com/saidmurod_davlatov",
                country: "TJ",
              },
              {
                name: "Озодхон Давлатшоев",
                title:
                  "Топ-менеджер, эксперт в сфере Telecom & Digital, Генеральный директор Tcell",
                topic:
                  " Тема презентация «От связи к цифровому доверию: Tcell как инфраструктурный уровень»",
                linkedin: "https://www.linkedin.com/in/ozodkhonceoiixviivi/",
                instagram: "https://www.instagram.com/ozodkhon.davlatshoev",
                country: "TJ",
              },
              {
                name: "Бехдад Зейнал Ганбар Нежад",
                title:
                  "Учредитель ООО «БуранПарс», предприниматель, амбассадор Московского экспортного центра в Иране, эксперт по российско-иранскому торгово-инвестиционному сотрудничеству.",
                topic:
                  "Тема презентации 'Иран-Центральная Азия: новые возможности инвестиций и сотрудничества'",
                linkedin: null,
                instagram: null,
                country: "IR",
              },
              {
                name: "Абдурашид Иминов",
                title:
                  "Основатель и генеральный директор Gōsht Group, международный предприниматель и эксперт в сфере ресторанного бизнеса и гостеприимства.",
                topic: "Тема презентации 'Стратегия международной экспансии'",
                linkedin:
                  "https://www.linkedin.com/in/abdurashid-iminov-05a8a7273/",
                instagram: "https://www.instagram.com/abdurashid_iminov",
                country: "UZ",
              },
              {
                name: "Харприт Сингх Маан",
                title:
                  "Генеральный директор TEIZA, Президент Blockchain Association Malaysia, серийный предприниматель и эксперт в области Blockchain и DLT.",
                topic:
                  "Тема презентации «Цифровой Таджикистан: сердце цифровой экономики Центральной Азии»",
                linkedin: "https://www.linkedin.com/in/harpreet-maan/",
                instagram: null,
                country: "MY",
              },
            ],
            agendaEyebrow: "Программа форума",
            agenda: [
              {
                time: "09:00 – 10:00",
                text: "Регистрация участников. Приветственный кофе",
              },
              { time: "10:00 – 10:30", text: "Церемония открытия форума" },
              { time: "10:30 – 13:00", text: "СЕССИЯ 1 — ИСТОРИИ УСПЕХА" },
              {
                time: "10:30 – 11:00",
                text: "Тэджун Шин (на английском языке) — Основатель, управляющий партнёр и генеральный директор Gojo & Company (Япония)\nТема: Gojo: Advancing Financial Inclusion in Central Asia and Beyond",
              },
              {
                time: "11:00 – 11:30",
                text: "Гаган Малхотра (на английском языке) — Предприниматель, инвестор, управляющий директор CHL International, владелец отеля Hilton Dushanbe. Заместитель председателя AmCham Tajikistan \nТема:Tourism: The Growth Engine for Tajikistan",
              },
              {
                time: "11:30 – 12:00",
                text: "Анастасия Анциферова — Предприниматель, бизнес-спикер и эксперт по развитию ресторанного бизнеса, маркетингу и управлению командами\nТема: От локальной идеи — к большому рынку: как ресторанный бренд становится инвестиционным продуктом",
              },
              {
                time: "12:00 – 12:30",
                text: "Саидмурод Давлатов — Основатель Международного центра развития человека «САМО», предприниматель, инвестор и бизнес-тренер\nТема: Система роста прибыли без увеличения нагрузки",
              },
              {
                time: "12:30 – 13:00",
                text: "Озодхон Давлатшоев — Топ-менеджер, эксперт в сфере Telecom & Digital, Генеральный директор Tcell\nТема: From Connectivity to Digital Trust: Tcell as the Infrastructure Layer of Tajikistan’s Digital Economy",
              },
              {
                time: "13:00 – 14:00",
                text: `Панельная сессия:
«Электронная коммерция как драйвер инвестиций: маркетплейсы, платежи и логистика нового поколения»

Модератор: Насима Бахрамова — председатель Ассоциации участников электронной коммерции Таджикистана

Предполагаемые участники панели:
• Ифтихор Юсуфи — маркетплейс LAK LAK
• Мухаммаджон Кудратуллозода — Мавсим и К
• Ярослав Ефремин — проект «Парвона»
• Бону Бобоева — Zehnlab.ai
• Гуланор Атобек — Представитель финтех-компании / платежной системы - Алиф Банк`,
              },
              { time: "14:00 – 15:00", text: "Обеденный перерыв" },
              {
                time: "15:00 – 17:30",
                text: "СЕССИЯ 2 — ИНВЕСТИЦИОННЫЕ ВОЗМОЖНОСТИ",
              },
              {
                time: "15:00 – 15:30",
                text: "Дилшод Джуразода — Генеральный директор ГУП «Таджинвест»\nТема: «Инвестиционные возможности Таджикистана»",
              },
              {
                time: "15:30 – 16:00",
                text: "Elena V. Son-LaRocco — Исполнительный директор Делового совета США — Таджикистан, бизнес-лидер и эксперт по развитию экономических связей между США и Центральной Азией\nТема: США и Центральная Азия: построение взаимовыгодных деловых партнерств",
              },
              {
                time: "16:00 – 16:30",
                text: "Бехдад Зейнал Ганбар Нежад — Учредитель ООО «БуранПарс», предприниматель, амбассадор Московского экспортного центра в Иране\nТема: Иран-Центральная Азия: новые возможности инвестиций и сотрудничества",
              },
              {
                time: "16:30 – 17:00",
                text: "Абдурашид Иминов — Основатель и генеральный директор Gōsht Group, международный предприниматель и эксперт в сфере ресторанного бизнеса и гостеприимства\nТема: «Стратегия международной экспансии»",
              },
              {
                time: "17:00 – 17:30",
                text: "Харприт Сингх Маан — Генеральный директор TEIZA, Президент Blockchain Association Malaysia, серийный предприниматель и эксперт в области Blockchain и DLT\nТема: “Digital Tajikistan: The Heart of Central Asia's Digital Economy”",
              },
              { time: "17:30 – 18:00", text: "Подведение итогов Форума" },
              {
                time: "18:00 – 18:30",
                text: "Торжественная церемония закрытия",
              },
            ],
            expoHeading: "Выставочная зона",
            expoTitle: "Представьте свой проект международной аудитории",
            expoText:
              "Презентуйте свою компанию, бизнес-проект, продукт или инновационное решение на G10 Insights Forum 2026. Представьте свои идеи предпринимателям, инвесторам, лидерам бизнеса и потенциальным партнёрам, установите новые деловые контакты и откройте возможности для сотрудничества и развития.",
            expoDeadline: "Приём заявок до 5 октября.",
            expoButton: "Подать заявку",
            expoImageLabel: "Фото выставочного островка",
            outcomesHeading: "Ожидаемые результаты",
            outcomes: [
              { title: "Практические инсайты" },
              { title: "Новые знания и опыт" },
              { title: "Международные партнёрства" },
              { title: "Новые деловые связи" },
              { title: "Совместные проекты и инициативы" },
              { title: "Новые возможности для роста" },
            ],
            organizersHeading: "Организаторы",
            organizerLogoLabel: "Логотип",
            organizers: [
              {
                name: "Государственный комитет по инвестициям и управлению государственным имуществом Республики Таджикистан",
              },
              {
                name: 'Государственное унитарное предприятие "Таджинвест"',
                highlight: "TAJINVEST",
              },
              {
                name: "Исполнительный орган государственной власти города Душанбе",
              },
            ],
            partnersHeading: "Партнёры",
            partnerCategories: [
              "Генеральный спонсор",
              "Спонсоры",
              "Партнёр по развитию",
              "Партнёры",
              "Медиа-партнёр",
            ],
            ctaTitle:
              "Станьте частью сообщества, которое формирует будущее бизнеса",
            ctaSubtitle: "Присоединяйтесь к G10 Insights Forum 2026",
          },
        },
      },
      tj: {
        translation: {
          lastTenders: "Тендерҳои охирин",
          viewAll: "Ҳамаро нигаред",
          viewPDF: "PDF-ро нигаред",
          lastContests: "Озмунҳои охирин",
          moreButton: "Бештар",
          advantagesSection: {
            title: "Афзалиятҳои Тоҷикистон",
            subtitle: "Чаро сармоягузорӣ кардан лозим аст:",
            items: [
              {
                icon: "FaHandshake",
                title: "Минтақаҳои озоди иқтисодӣ",
                description:
                  "Шартҳои имтиёзнок барои соҳибкорон ва сармоягузорон",
              },
              {
                icon: "FaGlobe",
                title: "Дастрасӣ ба бозорҳо",
                description:
                  "Ҷойгиршавии стратегӣ бо дастрасӣ ба бозорҳои Осиёи Марказӣ, Чин ва Ҳинд",
              },
              {
                icon: "FaChartBar",
                title: "Ҳамкорӣ байни давлат ва бахши хусусӣ",
                description: "Иҷрои лоиҳаҳои муштарак бо давлат",
              },
              {
                icon: "FaTint",
                title: "Барномаҳои дастгирӣ",
                description: "Имтиёзҳои молиявӣ ва ҳуқуқӣ барои соҳибкорӣ",
              },
              {
                icon: "FaMoneyBill",
                title: "Захираҳои бойи табиӣ",
                description:
                  "Потенсиали баланд барои рушди нерӯи обӣ ва дастрасӣ ба конҳои маъданӣ",
              },
              {
                icon: "FaUsers",
                title: "Сармояи инсонӣ",
                description: "Баландтарин фоизи аҳолии ҷавон дар Осиёи Марказӣ",
              },
            ],
          },
          showToursTitle: "Маълумоти бештар дар бораи сайр",
          NoAvailable: "Маълумот боргирӣ карда нашуд",
          NoTendersAvailable: "Айни замон тендер мавҷуд нест.",
          NoCompetitionsAvailable: "Айни замон озмун мавҷуд нест.",
          discover: {
            title: "Тоҷикистонро кашф кунед",
            subtitle: "Бо илҳом сармоягузорӣ кунед. Тоҷикистонро биёбед.",
            description:
              "Discover Tajikistan як сайёҳатҳои сармоягузорӣ дар минтақаҳои кишвар аст, ки имкониятҳои тиҷоратӣ бо мероси фарҳангӣ ва зебоиҳои табиӣ муттаҳид мешаванд.",
            programTitle: "Барнома иборат аст аз:",
            programItems: {
              visitCities:
                "дидани шаҳрҳои калидӣ ва маконҳои умедбахш (ба харита нигаред);",
              meetings: "дидорҳо бо намояндагони бизнес ва ҳукумат;",
              presentations: "презентатсияҳои лоиҳаҳои сармоягузорӣ;",
              hospitality:
                "ҳамчунин шомил шудан ба фазои меҳмоннавозии тоҷикистон.",
            },
            closingText:
              "Тоҷикистонро кашф кунед — дурнамоҳои нав барои сармоягузорӣ кушоед.",
            mapAlt: "Харитаи Тоҷикистон",
            tours: "Турҳо",
            backToTours: "Ба турҳо баргардед",
            back: "Ба ақиб баргардед",
            allTours: "Ҳамаи турҳо",
          },
          millionDollars: "миллион $",
          charts: {
            foreignInvestment: "Ҳаҷми воридоти сармояҳои хориҷӣ",
            externalTrade: "Ҳаҷми гардиши тиҷорати хориҷӣ",
            gdp: "ММД-и Тоҷикистон",
          },
          singleWindow: {
            title: "ONE-STOP SHOP",
            subtitle: "Чӣ пешниҳод мекунем:",
            services: [
              {
                title: "Рушди стратегияҳои сармоягузорӣ",
                description:
                  "Интихоби лоиҳаҳо ва идораи хатарҳо барои расидан ба ҳадафҳои сармоягузорӣ",
              },
              {
                title: "Ташкилоти форумҳои тиҷорӣ",
                description:
                  "Баргузории чорабинӣ барои мусоидат ба ҳамкорӣ байни сармоягузорон, соҳибкорон ва мақомоти давлатӣ",
              },
              {
                title: "Ҳамроҳсозии лоиҳаҳои сармоягузорӣ",
                description:
                  "Дастгирӣ дар ҳар марҳилаи сармоягузорӣ: аз нақшакашӣ то иҷро",
              },
              {
                title: "Ҳимояи ҳуқуқӣ",
                description: "Пешбурди пурраи ҳамроҳсозии ҳуқуқӣ барои лоиҳаҳо",
              },
              {
                title: "Маслиҳати андоз",
                description:
                  "Маслиҳатҳо оид ба масъалаҳои андозбандӣ барои оптимизатсияи хароҷоти андоз",
              },
              {
                title: "Машварат дар ҷустуҷӯи лоиҳаҳо",
                description:
                  "Кӯмак дар пайдоиш ва интихоб кардани лоиҳаҳои перспективӣ барои сармоягузорӣ",
              },
            ],
          },
          Competitions: "Озмунҳо",
          Tenders: "Тендерҳо",
          MapTitle: "Харитаи сармоягузории Тоҷикистон",
          region: "минтақа",
          description: "тавсиф",
          filter: "Тартиб додан аз рӯи самтҳо",
          GBAO: "ВМКБ",
          Sogd: "Суғд",
          RRP: "НТҶ",
          Khatlon: "Хатлон",
          InvestGuide: "Дастури сармоягузор",
          All: "Ҳамма",
          AllProjects: "Ҳама лоиҳаҳо",
          WholeMap: "Харитаи пурра",
          emblemTitle:
            "Кумитаи давлатии сармоягузорӣ ва идораи амволи давлатии Ҷумҳурии Тоҷикистон",
          "Latest news": "Хабарҳои охирин",
          logoTitle: "Корхонаи воҳиди давлатии ",
          logoTaj: '"Тоҷинвест"',
          LatestCompetitions: "Мусобиқаҳои охирин",
          "An error occurred. Please try again.":
            "Хатогӣ рух дод. Лутфан боз кӯшиш кунед.",
          "Successfully sent!": "Муваффақона фиристода шуд!",
          Gotothejobopeningspage: "Ба саҳифаи ҷойҳои холии кор гузаред",
          JobShow: "Маълумот дар бораи ҷойи кор",
          "View All": "Тамоми маълумот",
          projectCoverageMapMenu: "Ба сармоягузорон",
          NumberofVacancies: "Миқдори вазифаҳо",
          LatestVacancies: "Вакансияҳои охирин",
          MoreDetails: "Маълумоти бештар",
          "Agency Vacancies": "Шумораи вазифаҳо",
          AgencyDecr:
            "Дарҳои мо барои касон, ки мехоҳанд қисми сохтори инноватсионӣ дар Тоҷикистон шаванд, кушода аст.",
          ImportanttoKnow: " Мухим аст, ки донед",
          ImportanttoKnowDescr:
            "Аризаи электронӣ аз шаҳрванд бояд ҳатман дорои насаб, ном, номи падар ё инициали шаҳрванд, суроғаи ҷойгиршавии шаҳрванд (ҷойи иқомат), тавсифи муҳтавои ариза ва суроғаи почтаи электронии шаҳрванд бошад. Аризаи электронӣ аз шахси ҳуқуқӣ бояд ҳатман дорои номи пурраи шахси ҳуқуқӣ, ҷойи қарор доштани шахси ҳуқуқӣ, тавсифи муҳтавои ариза, насаб, ном, номи падарии шахсе, ки ҳуқуқи имзо гузоштан ба аризаҳоро дорад ва суроғаи почтаи электронии шахси ҳуқуқӣ бошад. Аризаҳои электронӣ бояд на дертар аз 15 рӯз аз рӯзи сабти ном баррасӣ шаванд ва онҳо, ки таҳқиқи иловагӣ ва санҷишро талаб мекунанд, на дертар аз 1 моҳ баррасӣ шаванд.",
          Message: "Нақша",
          MessageDescr:
            "Мо шуморо иттилоъ медиҳем, ки истифодаи ҳуқуқи шумо барои пешниҳод кардани ариза дар шакли ҳуҷҷати электронӣ тибқи қонунгузории Ҷумҳурии Тоҷикистон анҷом дода мешавад, ки муҳофизат аз ҳуқуқи пӯшидагиҳои шахсӣ, сирри шахсӣ ва оилавӣ таъмин карда мешавад, ба ин манзур, пешгирии паҳн кардани маълумот дар бораи масири аризаҳои шумо ва фош кардани маълумоте, ки дар аризаҳои шумо ва марбут ба ҳаёти шахсии шумо мебошад, ва риояи талабот барои коркарди маълумоти шахсии шумо.",
          Explorethemap:
            "Хартаро дар бораи лоиҳаҳои инноватсионӣ, ки дар ҳоли амал ва ба итмом расид, дар саросари Тоҷикистон омӯзед.",
          ProjectCoverageMap: "Хартаи пӯшииши лоиҳаҳо",
          SupervisedDirections: "Самтҳои таҳти назорат",
          DirectorPhone: "Телефон",
          DirectoroftheAgency: "Директор",
          ReceptionSchedule: "Ҷадвали қабули меҳмонон",
          Structure: "Сохтор",
          NameIn:
            "АГЕНТИ ИННОВАТСИЯ ВА ТЕХНОЛОГИЯҲОИ РАҚАМӢ НАЗДИ ПРЕЗИДЕНТИ ҶУМҲУРИИ ТОҶИКИСТОН",
          search: "Ҷустуҷӯ",
          menu: "Меню",
          news: "Хабар",
          seeEveryNews: "Ба ҳама хабарҳо",
          "Read more": "Бештар",
          Activity: "Фаъолият",
          ActivityDescription:
            "Маркази хабарҳо оид ба сармоягузорӣ дар Тоҷикистон — ташаббусҳо, дурнамо ва натиҷаҳо.",
          "Digitalization and goals": "Рақамӣ ва ҳадафҳо",
          "Achieving 'digital maturity' of key sectors of the economy and social sphere. Creating foundations and potential for the development of an economy based on innovation and knowledge":
            "Даст ёфтан ба 'расидани рақамӣ' дар соҳаҳои калидии иқтисодиёт ва иҷтимоӣ. Эҷоди асосҳо ва потенсиали рушди иқтисодиёт дар асоси навоварӣ ва дониш",
          "Development of strategies": "Рушди стратегияҳо",
          "Promotion of a unified state policy in the field of innovation and digital technology development":
            "Пешбурди сиёсати ягонаи давлатӣ дар соҳаи рушди инноватсия ва технологияҳои рақамӣ",
          "Infrastructure development": "Сарвати инсонӣ",
          "Provision of public services in digital form":
            "Таъмини хизматрасониҳои давлатӣ дар шакли рақамӣ",
          "Security and regulation": "Амният ва танзим",
          "Management and regulation of the process of using electronic signatures and data protection":
            "Идоракунӣ ва танзими раванди истифодаи имзои электронӣ ва ҳифзи маълумотҳо",
          "Implementation of e-government": "Ҷорӣ кардани ҳукумати электронӣ",
          "Management and regulation of the implementation of 'e-government'":
            "Идоракунӣ ва танзими раванди ҷорӣ кардани 'ҳукумати электронӣ'",
          "Business and innovation support":
            "Дастгирии тиҷорат ва инноватсияҳо",
          "Promotion of the digital economy and e-commerce":
            "Пешбурди иқтисодиёти рақамӣ ва тиҷорати электронӣ",

          agencyTasks: "Вазифаҳои агентӣ",
          agencyDescription:
            "Тезонидани рушди иқтисодӣ барои эҷоди иқлими фарогир, рақобатпазир ва тиҷоратӣ.",
          task1:
            "Ташкил, идора ва пешбурди раванди эҷоди шароити мусоид барои рушди рақамии соҳаи иқтисодӣ ва иҷтимоии Ҷумҳурии Тоҷикистон.",
          task2:
            "Муайян кардани марҳилаҳои гузариш ба низоми рақамии танзими муносибатҳои давлат бо аҳолӣ ва бахши хусусӣ.",
          task3:
            "Муайян кардани зарурат ва имконияти ташаккул ва татбиқи инфрасохтор барои таъмини рақамисозӣ.",
          task4:
            "Танзим ва пешбурди фаъолияти марказҳои хизматрасонии давлатӣ, марказҳои тасдиқкунанда ва таҳияи барномаҳои рақамӣ.",
          task5:
            "Муайян кардани самтҳои рушди инноватсионӣ ва асосҳои дастгирии давлатии фаъолияти инноватсионӣ дар Ҷумҳурии Тоҷикистон.",
          task6:
            "Ташкили механизми тиҷоратӣ кардани натиҷаҳои илмӣ ва техникии табиати инноватсионӣ.",

          agencyIssues: "Агентии ҳалли масъалаҳои зерин",
          agencyIssueDescription:
            "Тезонидани рушди иқтисодӣ бо мақсади фароҳам овардани фазои фарогир, рақобатпазир ва мусоиди соҳибкорӣ.",
          solution1:
            "Рушди инфрасохтори системаи 'Ҳукумати электронӣ', ки ба васеъ истифода бурдани технологияҳои муосири иттилоотӣ-коммуникатсионӣ дар соҳаи хизматрасониҳои давлатӣ ва ҳамкории идоравӣ байни идораҳо таъсир мерасонад.",
          solution2:
            "Рушди инфрасохтори системаи 'Ҳукумати электронӣ', ки ба васеъ истифода бурдани технологияҳои муосири иттилоотӣ-коммуникатсионӣ дар соҳаи хизматрасониҳои давлатӣ ва ҳамкории идораҳои байниидоравӣ таъсир мерасонад.",
          solution3:
            "Рушди инфрасохтори системаи 'Ҳукумати электронӣ', ки ба васеъ истифода бурдани технологияҳои муосири иттилоотӣ-коммуникатсионӣ дар соҳаи хизматрасониҳои давлатӣ ва ҳамкории идораҳои байниидоравӣ таъсир мерасонад",

          "Contact us": "Бо мо тамос гиред",
          name: "Ном",
          email: "Почтаи электронӣ",
          "type messeg": "Мавзӯи паём:",
          messeg: "Паём",
          Send: "Фиристодан",
          "Enter your name": "Номи худро ворид кунед",
          "Enter your email": "Почтаи электронии худро ворид кунед",
          "Enter your messeg": "Паёми худро ворид кунед",
          "type messeg select": "Мавзӯъро интихоб кунед",
          topicOne: "Нависидани мактуб",
          topicTwo: "Хабар додан дар бораи коррупсия",
          topicThree: "Муроҷиати дастаҷамъона",
          FAQ: "Равзанаи ягона",
          million: "млн",
          attashe: "Муовинони сармоягузорӣ",

          NumbersTJK: "Тоҷикистон дар рақамҳо",
          averageAge: "Синну миёна",
          population: "Аҳолӣ",
          gdpRankCIS: "Ҷойгоҳ дар афзоиши ИҚМ дар ИДМ",
          gdpRankCA: "Ҷойгоҳ дар афзоиши ИҚМ дар Осиёи Марказӣ",
          youngPopulation: "Тааҷҷуби аҳолӣ зери 35 сол",
          benefits: "Имтиёзҳо ва афзалиятҳо",
          foreignInvestment: "Сармоягузориҳои хориҷӣ (млн доллари ИМА)",
          gdpGrowth: "Рушди ИҚМ",

          address: "Суроға: 734025, Тоҷикистон, Душанбе, хиёбони Рӯдакӣ 40",
          addresss: "",
          phone: "Телефон:",
          emaill: "Почтаи электронӣ: info@tajinvest.tj",
          date: "Санаи таҳсис",
          home: "Саҳифаи асосӣ",
          activity: "Фаъолият",
          appeals: "Муроҷиатҳо",
          leadership: "Роҳбарият",
          legislativeBase: "Заминаи қонунгузорӣ",
          vacancies: "Вакансияҳо",
          projectCoverageMap: "Харитаи пӯшиши лоиҳаҳо",
          announcements: "Эълонҳо",

          MainTitle: "Тоҷикистон — сармоягузорӣ ба инсон ва иқтидор",
          MainDescription: "Ба бозори рушдёбанда ҳамроҳ шавед",
          projectPr:
            "Яке аз вазифаҳои муҳим ин фароҳам овардани фазои мусоиди сармоягузорӣ ва соҳибкорӣ, дастгирии сармоягузорони дохилӣ ва хориҷӣ ва ҷалби сармоягузориҳои мустақим дар соҳаҳои стратегии иқтисодиёт мебошад.",
          PresidentName:
            "Асосгузори сулҳ ва ваҳдати миллӣ – Пешвои миллат, Президенти Ҷумҳурии Тоҷикистон Эмомалӣ Раҳмон",
          titleProject: "Мухтасар дар бораи фаъолияти мо",
          DescriptionProject:
            'Миссияи КВД  "Таджинвест" — мусоидат ба рушди иқтисодии Тоҷикистон тавассути ҷалби сармоягузорӣ, дастгирии соҳибкорӣ ва рушди активҳои давлатӣ, бо эҷоди шароити мусоид барои тиҷорати муваффақ.',
          Projects: "Лоиҳаҳо",
          titleMaps: "Минтақаҳои инноватсионӣ",
          "Re more maps": "Бештар",
          "Latest projects": "Лоиҳаҳои охирин",
          "More details": "Тафсилоти бештар",
          Sifrtitle: "Афзалиятҳои сармоягузорӣ дар Тоҷикистон ",
          SifrDescription:
            "Имкониятҳои навро дар минтақаи босуръат рушдёбанда кашф намоед — шароити мусоид, захираҳои табиӣ ва нерӯи кории ҷавон шуморо дар Тоҷикистон интизоранд.",

          "Sifr solotions title1": "Минтақаҳои озоди иқтисодӣ",
          "Sifr solotions descriptions1":
            "Шароитҳои имтиёзнок барои соҳибкорон ва сармоягузорон",
          "Sifr solotions title2": "Татбиқи ҳукумати электронӣ",
          "Sifr solotions descriptions2":
            "Баландтарин фоизи аҳолии ҷавон дар Осиёи Марказӣ",
          "Sifr solotions title3": "Шарикӣ миёни давлат ва бахши хусусӣ",
          "Sifr solotions descriptions3": "Иҷрои лоиҳаҳои муштарак бо давлат",
          "Sifr solotions title4": "Дастрасӣ ба бозорҳо",
          "Sifr solotions descriptions4":
            "Ҷойгиршавии судманд бо дастрасӣ ба бозорҳои Осиёи Марказӣ, Чин ва Ҳинд",
          "Sifr solotions title5": "Захираҳои бойи табиӣ",
          "Sifr solotions descriptions5":
            "Потенсиали бузург барои рушди гидроэнергетика ва дастрасӣ ба захираҳои маъданӣ",
          "More about the agency": "Бештар",
          investForum: {
            menu: "G10 Insights Forum",
            breadcrumbHome: "Асосӣ",
            breadcrumbEvents: "Чорабиниҳо",
            breadcrumbCurrent: "G10 Insights Forum 2026",
            logoTitle: "G10",
            logoSubLine1: "ФОРУМИ ИНСАЙТҲО",
            logoSubLine2: "2026",
            heroTitle: "G10 Insights Forum 2026",
            heroTagline:
              "Форуми байналмилалии ғояҳо, соҳибкорӣ ва имкониятҳои нав",
            heroTagline2: "",
            locationCity: "Душанбе, Тоҷикистон",
            venue: "Кохи Ваҳдат",
            date: "15 октябри соли 2026",
            registerNow: "Хариди билет",
            downloadProgram: "БАРНОМАРО БОРГИРӢ КАРДАН",
            downloadConcept: "Боргирии консепсия",
            learnMore: "Бештар донед",
            viewAllSpeakers: "Ҳамаи баромадкунандагон",
            learnMoreAboutForum: "Дар бораи форум бештар донед",
            heroImageLabel: "Сурати заминавӣ",
            stats: [
              { value: "1000+", label: "Иштирокчиён" },
              { value: "10", label: "Баромадкунандагони ҷаҳонӣ" },
              { value: "50+", label: "Кишварҳо" },
              { value: "100+", label: "Вохӯриҳои сармоягузорӣ" },
            ],
            aboutEyebrow: "Дар бораи форум",
            aboutTitle: "G10 Insights Forum",
            aboutText1:
              "G10 Insights Forum — платформаи байналмилалии тиҷоратӣ мебошад, ки соҳибкорони муваффақ, сармоягузорон, роҳбарони ширкатҳо ва коршиносонро барои мубодилаи таҷрибаи амалӣ, ғояҳо ва стратегияҳои рушди тиҷорат муттаҳид менамояд.",
            aboutText2:
              "Форум ба иштирокчиён имконият медиҳад, ки бо таърихи воқеии муваффақият, қарорҳои калидии тиҷоратӣ ва таҷрибаи касбии роҳбарон аз кишварҳои гуногун шинос шуда, робитаҳои нави корӣ барқарор намоянд, шарикиро рушд диҳанд ва имкониятҳои навро барои тиҷорат ва сармоягузорӣ кашф кунанд.",
            aboutImageLabel: "Сурати мубоҳисаи гурӯҳӣ",
            missionHeading: "Мақсад ва ҳадафҳо",
            missionGoals: [
              {
                title: "МУБОДИЛАИ ТАҶРИБА ВА ИНСАЙТҲО",
                text: "Ташкили платформаи байналмилалӣ барои мубодилаи донишҳои амалӣ, таҷриба ва ғояҳо миёни соҳибкорон, сармоягузорон ва пешвоёни тиҷорат.",
              },
              {
                title: "ТАЪРИХҲОИ МУВАФФАҚИЯТ",
                text: "Шиносоӣ бо роҳи касбии роҳбарон, қарорҳои калидӣ, стратегияҳои рушд ва таҷрибаи онҳо дар таъсис ва тавсеаи тиҷорати муваффақ.",
              },
              {
                title: "ҶОМЕАИ ПЕШВОЁНИ ТИҶОРАТ",
                text: "Муттаҳид намудани соҳибкорон, сармоягузорон, роҳбарони ширкатҳо ва коршиносон аз кишварҳои гуногун дар як платформаи касбӣ.",
              },
              {
                title: "ИМКОНИЯТҲОИ НАВ БАРОИ РУШД",
                text: "Эҷоди робитаҳои нави корӣ, рушди шарикӣ ва фароҳам овардани имкониятҳои нав барои тиҷорат, сармоягузорӣ ва лоиҳаҳои муштарак.",
              },
            ],
            speakersHeading: "Баромадкунандагон",
            speakerPhotoLabel: "Сурати баромадкунанда",
            speakers: [
              {
                name: "Дилшод Ҷуразода",
                title:
                  "Директори генералии Корхонаи воҳиди давлатии «Таджинвест».",
                topic:
                  'Мавзӯи муаррифӣ: "Имкониятҳои сармоягузории Тоҷикистон"',
                linkedin:
                  "https://www.linkedin.com/in/dilshod-jurazoda/?locale=ru",
                instagram: "https://www.instagram.com/iamdi55erent/",
                country: "TJ",
              },
              {
                name: "Гаган Малхотра",
                title:
                  "Соҳибкор, сармоягузор, директори идоракунандаи CHL International ва соҳиби меҳмонхонаи Hilton Dushanbe. Муовини раиси Палатаи савдои Амрико дар Тоҷикистон (AmCham Tajikistan).",
                topic: 'Мавзӯи муаррифӣ: "Сайёҳӣ: муҳаррики рушди Тоҷикистон"',
                linkedin:
                  "https://www.linkedin.com/in/gagan-malhotra-18362414/",
                instagram: null,
                country: "IN",
              },
              {
                name: "Елена Сон-ЛаРокко",
                title:
                  "Директори иҷроияи Шӯрои тиҷоратии ИМА–Тоҷикистон, пешвои бизнес ва мутахассис оид ба рушди робитаҳои иқтисодӣ байни ИМА ва Осиёи Марказӣ.",
                topic:
                  'Мавзӯи муаррифӣ: " ИМА ва Осиеи Марказй: рохандозии шарикии мутакобилан судманди тичоратӣ"',
                linkedin: "https://www.linkedin.com/in/elenavson/",
                instagram: null,
                country: "US",
              },
              {
                name: "Теҷун Шин",
                title:
                  "Асосгузор, шарики идоракунанда ва директори генералии Gojo & Company (Ҷопон).",
                topic:
                  "Мавзӯи муаррифӣ: Gojo Пешбурди фарогирии молиявӣ дар Осиёи Марказӣ ва берун аз он",
                linkedin: "https://www.linkedin.com/in/taejun-shin-185480a5/",
                instagram: null,
                country: "JP",
              },
              {
                name: "Анастасия Анциферова",
                title:
                  "Соҳибкор, сухангӯи бизнес ва мутахассис оид ба рушди бизнеси тарабхонаҳо, маркетинг ва идоракунии дастаҳо.",
                topic:
                  "Мавзӯи муаррифӣ: «Тaьсиси тарабхонаи консептуалй аз сифр е харидани франшиза тачриба аз ду чониб»",
                linkedin: null,
                instagram: "https://www.instagram.com/marpha_feeling_good",
                country: "RU",
              },
              {
                name: "Саидмурод Давлатов",
                title:
                  "Асосгузори Маркази байналмилалии рушди инсонии «САМО», соҳибкор, сармоягузор ва мураббии бизнес.",
                topic:
                  'Мавзӯи муаррифӣ:  "Системаи рушди фоида бе зиёд кардани бори корӣ"',
                linkedin:
                  "https://www.linkedin.com/in/%D1%81%D0%B0%D0%B8%D0%B4%D0%BC%D1%83%D1%80%D0%BE%D0%B4-%D0%B4%D0%B0%D0%B2%D0%BB%D0%B0%D1%82%D0%BE%D0%B2-a9953a263/",
                instagram: "https://www.instagram.com/saidmurod_davlatov",
                country: "TJ",
              },
              {
                name: "Озодхон Давлатшоев",
                title:
                  "Топ-менеҷер, коршинос дар соҳаи телекоммуникатсия ва технологияҳои рақамӣ, Директори генералии Tcell.",
                topic:
                  'Мавзӯи муаррифӣ: "Аз пайвастшавӣ то эътимоди рақамӣ: Tcell ҳамчун қабати инфрасохтории иқтисоди рақамии Тоҷикистон"',
                linkedin: "https://www.linkedin.com/in/ozodkhonceoiixviivi/",
                instagram: "https://www.instagram.com/ozodkhon.davlatshoev",
                country: "TJ",
              },
              {
                name: "Беҳдод Зейнал Ганбар Неҷод",
                title:
                  "Муассиси ҶДММ «БуранПарс», соҳибкор, сафири Маркази содиротии Маскав дар Эрон ва мутахассиси ҳамкориҳои тиҷоративу сармоягузории Русия ва Эрон.",
                topic:
                  "Мавзӯи муаррифӣ: «Эрон — Осиёи Марказӣ: имкониятҳои нави сармоягузорӣ ва ҳамкорӣ»",
                linkedin: null,
                instagram: null,
                country: "IR",
              },
              {
                name: "Абдурашид Иминов",
                title:
                  "Асосгузор ва директори генералии Gōsht Group, соҳибкори байналмилалӣ ва мутахассис дар соҳаи тиҷорати тарабхонаҳо ва меҳмоннавозӣ.",
                topic: 'Мавзӯи муаррифӣ:  "Стратегияи тавсеаи байналмилалӣ"',
                linkedin:
                  "https://www.linkedin.com/in/abdurashid-iminov-05a8a7273/",
                instagram: "https://www.instagram.com/abdurashid_iminov",
                country: "UZ",
              },
              {
                name: "Харприт Сингх Маан",
                title:
                  "Директори генералии TEIZA, Президенти Blockchain Association Malaysia, соҳибкори силсилавӣ ва мутахассис дар соҳаи Blockchain ва DLT.",
                topic:
                  'Мавзӯи муаррифӣ:  "Тоҷикистони рақамӣ: қалби иқтисоди рақамии Осиёи Марказӣ"',
                linkedin: "https://www.linkedin.com/in/harpreet-maan/",
                instagram: null,
                country: "MY",
              },
            ],
            agendaEyebrow: "Барномаи форум",
            agenda: [
              {
                time: "09:00 – 10:00",
                text: "Сабти номи иштирокчиён. Қаҳваи хушомадгӯӣ",
              },
              { time: "10:00 – 10:30", text: "Маросими ифтитоҳи форум" },
              {
                time: "10:30 – 13:00",
                text: "ҶАЛАСАИ 1 — ТАЪРИХҲОИ МУВАФФАҚИЯТ",
              },
              {
                time: "10:30 – 11:00",
                text: "Тэджун Шин (бо забони англисӣ) — Асосгузор, шарики идоракунанда ва директори генералии Gojo & Company (Ҷопон)\nМавзӯъ: Gojo: Advancing Financial Inclusion in Central Asia and Beyond",
              },
              {
                time: "11:00 – 11:30",
                text: "Гаган Малхотра (бо забони англисӣ) — Директори генералии CHL International, ширкати соҳиби Hilton Dushanbe. Шарики идоракунандаи Amnis Ventures FZCO (Дубай) ва муовини раиси AmCham дар Тоҷикистон\nМавзӯъ: Сайёҳӣ: муҳаррики рушди Тоҷикистон",
              },
              {
                time: "11:30 – 12:00",
                text: "Анастасия Анциферова — Соҳибкор, спикери бизнес ва коршиноси рушди соҳаи тарабхонадорӣ, маркетинг ва идоракунии дастаҳо\nМавзӯъ: Аз ғояи маҳаллӣ — ба бозори бузург: чӣ гуна бренди тарабхона ба маҳсулоти сармоягузорӣ табдил меёбад",
              },
              {
                time: "12:00 – 12:30",
                text: "Саидмурод Давлатов — Асосгузори Маркази байналмилалии рушди инсон «САМО», соҳибкор, сармоягузор ва мураббии бизнес\nМавзӯъ: Системаи рушди фоида бе зиёд кардани бори корӣ",
              },
              {
                time: "12:30 – 13:00",
                text: "Озодхон Давлатшоев — Топ-менеҷер, коршинос дар соҳаи телекоммуникатсия ва технологияҳои рақамӣ, Директори генералии Tcell\nМавзӯъ: From Connectivity to Digital Trust: Tcell as the Infrastructure Layer of Tajikistan’s Digital Economy",
              },
              {
                time: "13:00 – 14:00",
                text: `Ҷаласаи панелӣ:
«Тиҷорати электронӣ ҳамчун омили рушди сармоягузорӣ: маркетплейсҳо, пардохтҳо ва логистикаи насли нав»

Модератор: Насима Баҳромова — раиси Ассотсиатсияи иштирокчиёни тиҷорати электронии Тоҷикистон

Иштирокчиёни эҳтимолии панел:
• Ифтихор Юсуфӣ — маркетплейси LAK LAK
• Мухаммаджон Кудратуллозода — Мавсим ва К
• Ярослав Ефремин — лоиҳаи «Парвона»
• Бону Бобоева — Zehnlab.ai
• Гуланор Атобек — намояндаи ширкати финтекӣ / низоми пардохтӣ - Алиф Бонк`,
              },
              { time: "14:00 – 15:00", text: "Таваққуфи нисфирӯзӣ" },
              {
                time: "15:00 – 17:30",
                text: "ҶАЛАСАИ 2 — ИМКОНИЯТҲОИ САРМОЯГУЗОРӢ",
              },
              {
                time: "15:00 – 15:30",
                text: "Дилшод Ҷуразода — Директори генералии КВД «Тоҷинвест»\nМавзӯъ: «Имкониятҳои сармоягузории Тоҷикистон»",
              },
              {
                time: "15:30 – 16:00",
                text: "Elena V. Son-LaRocco — Директори иҷроияи Шӯрои тиҷоратии ИМА — Тоҷикистон, пешвои бизнес ва коршиноси рушди робитаҳои иқтисодӣ байни ИМА ва Осиёи Марказӣ\nМавзӯъ: ИМА ва Осиеи Марказй: рохандозии шарикии мутакобилан судманди тичоратӣ ",
              },
              {
                time: "16:00 – 16:30",
                text: "Беҳдод Зайнал Ғанбар Нежод — Муассиси ҶДММ «БуранПарс», соҳибкор, сафири Маркази содиротии Москва дар Эрон\nМавзӯъ: Эрон — Осиёи Марказӣ: имкониятҳои нави сармоягузорӣ ва ҳамкорӣ",
              },
              {
                time: "16:30 – 17:00",
                text: "Абдурашид Иминов — Асосгузор ва директори генералии Gōsht Group, соҳибкори байналмилалӣ ва коршиноси соҳаи тарабхонадорӣ ва меҳмоннавозӣ\nМавзӯъ: «Стратегияи тавсеаи байналмилалӣ»",
              },
              {
                time: "17:00 – 17:30",
                text: "Харприт Сингҳ Маан — Директори генералии TEIZA, Раиси Blockchain Association Malaysia, соҳибкори силсилавӣ ва коршиноси соҳаи блокчейн ва DLT\nМавзӯъ: “Digital Tajikistan: The Heart of Central Asia's Digital Economy”",
              },
              { time: "17:30 – 18:00", text: "Ҷамъбасти Форум" },
              {
                time: "18:00 – 18:30",
                text: "Маросими расмии хотимавии форум",
              },
            ],
            expoHeading: "Минтақаи намоишгоҳ",
            expoTitle:
              "Лоиҳаи худро ба аудиторияи байналмилалӣ муаррифӣ намоед",
            expoText:
              "Ширкат, лоиҳаи тиҷоратӣ, маҳсулот ё ҳалли инноватсионии худро дар G10 Insights Forum 2026 муаррифӣ намоед. Ғояҳои худро ба соҳибкорон, сармоягузорон, пешвоёни тиҷорат ва шарикони эҳтимолӣ пешниҳод намуда, робитаҳои нави корӣ барқарор кунед ва имкониятҳои навро барои ҳамкорӣ ва рушд пайдо намоед.",
            expoDeadline: "Қабули дархостҳо то 5 октябр идома меёбад.",
            expoButton: "Дархост пешниҳод кунед",
            expoImageLabel: "Сурати ҷазираи намоишгоҳ",
            outcomesHeading: "Натиҷаҳои интизоршаванда",
            outcomes: [
              { title: "Андешаҳои амалӣ" },
              { title: "Дониш ва таҷрибаи нав" },
              { title: "Шарикиҳои байналмилалӣ" },
              { title: "Робитаҳои нави корӣ" },
              { title: "Лоиҳаҳо ва ташаббусҳои муштарак" },
              { title: "Имкониятҳои нав барои рушд" },
            ],
            organizersHeading: "Ташкилкунандагон",
            organizerLogoLabel: "Нишон",
            organizers: [
              {
                name: "Кумитаи давлатии сармоягузорӣ ва идораи амволи давлатии Ҷумҳурии Тоҷикистон",
              },
              {
                name: 'Ширкати воҳиди давлатии "Тоҷинвест"',
                highlight: "TAJINVEST",
              },
              { name: "Мақоми иҷроияи ҳокимияти давлатии шаҳри Душанбе" },
            ],
            partnersHeading: "Шарикон",
            partnerCategories: [
              "Сарпарасти генералӣ",
              "Спонсорон",
              "Шарики рушд",
              "Шарикон",
              "Медиа-шарик",
            ],
            ctaTitle:
              "Қисми ҷомеае бошед, ки ояндаи тиҷоратро ташаккул медиҳад",
            ctaSubtitle: "Ба G10 Insights Forum 2026 ҳамроҳ шавед",
          },
        },
      },
    },
    fallbackLng: "ru",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
